import axios from 'axios'
import { createAuthenticatedClient } from './authenticatedClient'
import { platformEnv } from '@/platform/config/env'
import { requireSessionTokens, requireUser } from '../session/validation'

const client = createAuthenticatedClient(platformEnv.ssoApiUrl)

export const authApi = {
  async me() {
    const response = await client.get('/v1/auth/me')
    return requireUser(response.data)
  },
  async logout() {
    await client.post('/v1/auth/logout')
  },
  async exchangeCode(code: string) {
    const response = await axios.post(`${platformEnv.ssoApiUrl}/v1/auth/exchange-code`, { code }, { timeout: 10_000 })
    return requireSessionTokens(response.data)
  },
}
